import { cn } from "packages/dsaui/src/utils";

export const PageShell = ({
  children,
  className,
}: React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>) => (
  <main className="bg-gray-50 px-0 py-8 md:px-8 md:py-10">
    <div className={cn("mx-auto flex w-full flex-col gap-8", className)}>
      {children}
    </div>
  </main>
);
